import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogIn, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

interface LoginSectionProps {
  user?: any;
}

export default function LoginSection({ user }: LoginSectionProps) {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    if (!user) {
      navigate('/login');
    }
  };

  // Si el usuario ya está logueado, no mostrar esta sección
  if (user) {
    return null;
  }

  return (
    <section id="iniciar-sesion" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-12 shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <LogIn className="w-8 h-8 text-blue-600" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Iniciar Sesión
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
              Accedé a tu cuenta para continuar tu aprendizaje y acceder a recursos exclusivos
            </p>
            <Button
              onClick={handleLoginClick}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              Iniciar Sesión
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

